@if (!isMobilePreview) {
<app-header [class.main-page-header]="isMainPage"></app-header>

<app-airports-slider
  [class.hidden-by-terms]="(modal.isTermsOpen$ | async) ?? false">
</app-airports-slider>
}

<router-outlet/>

<app-modal-terms
  [isOpen]="(modal.isTermsOpen$ | async) ?? false"
  [service]="(modal.termsService$ | async)"
  (closed)="modal.closeTerms()"
  (accepted)="modal.acknowledgeTerms()"
>
</app-modal-terms>
